/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-30 14:52:10
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 10:51:19
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/commonHooks.ts
 */
import { useEffect } from 'react';
const useProductsHasUpdate = (
  products,
  setMappedSelectedKeys,
  setSelectedRowKeys,
  updateMappedSelectedKeys,
) => {
  useEffect(() => {
    const _keys = updateMappedSelectedKeys();

    ///新的初始化
    const _selected = [];
    for (const product of products) {
      const { uuid } = product;
      if (_keys[uuid]) {
        if (_keys[uuid].checked) {
          _selected.push({ uuid, product });
        }
        _keys[uuid].current = true; //如果原来没有选就没有初始化对象
      }
    }

    setMappedSelectedKeys(_keys);
    setSelectedRowKeys(_selected);
  }, [products]);
};

export { useProductsHasUpdate };
